import React from 'react';
import { Button, Popover, PopoverHeader, PopoverBody } from 'reactstrap';

export default class HelpPopover extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      size: this.props.size || 'md',
    };
  }

  toggle = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({ open: !this.state.open });
  }

  render() {
    return (<Button
      color="secondary"
      className="help-popover"
      size={this.state.size}
      id={this.props.name}
      onClick={this.toggle}
    >
      <i className="fa fa-info" />
      <Popover
        placement={this.props.placement || 'bottom'}
        isOpen={this.state.open}
        target={this.props.name}
        toggle={this.toggle}
        onClick={this.toggle}
      >
        <PopoverHeader>
          {this.props.title}
          <Button
            size='sm'
            className="float-md-end"
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              padding: 0,
              color: 'gray',
            }}
          >x</Button>
        </PopoverHeader>
        <PopoverBody>
          {this.props.children}
        </PopoverBody>
      </Popover>
    </Button>);
  }
}
